import * as Sentry from "@sentry/browser";
import {initializeApp} from "firebase/app";
import {connectDatabaseEmulator, getDatabase} from "firebase/database";
import {getStorage, connectStorageEmulator} from "firebase/storage";
import {browserLocalPersistence, connectAuthEmulator, getAuth, setPersistence} from "firebase/auth";
import {getFunctions, connectFunctionsEmulator} from "firebase/functions";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY.trim(),
  authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN.trim(),
  databaseURL: import.meta.env.VITE_APP_FIREBASE_DATABASE_URL.trim(),
  projectId: import.meta.env.VITE_APP_FIREBASE_PROJECT_ID.trim(),
  storageBucket: import.meta.env.VITE_APP_FIREBASE_STORAGE_BUCKET_URL.trim(),
  messagingSenderId: import.meta.env.VITE_APP_FIREBASE_MESSAGING_SENDER_ID.trim(),
  appId: import.meta.env.VITE_APP_FIREBASE_APP_ID.trim(),
  measurementId: import.meta.env.VITE_APP_FIREBASE_MEASUREMENT_ID.trim(),
};
const app = initializeApp(firebaseConfig);

const connectToDatabase = () => {
  if (import.meta.env.VITE_APP_FIREBASE_EMULATOR_URL !== undefined) {
    const database = getDatabase(undefined, import.meta.env.VITE_APP_FIREBASE_EMULATOR_URL.trim());
    connectDatabaseEmulator(database, "localhost", 9000);
    return database;
  }

  return getDatabase(app);

}

export const auth = getAuth(app);

if (import.meta.env.VITE_APP_AUTH_EMULATOR_URL !== undefined) {
  connectAuthEmulator(auth, import.meta.env.VITE_APP_AUTH_EMULATOR_URL.trim());
}

setPersistence(auth, browserLocalPersistence)
    .then(() => {
    }).catch((error) => {
  Sentry.captureException(error);
});

export const storage = getStorage(app);

if (import.meta.env.VITE_APP_STORAGE_EMULATOR_PORT !== undefined) {
  connectStorageEmulator(storage, "127.0.0.1", parseInt(import.meta.env.VITE_APP_STORAGE_EMULATOR_PORT.trim()));
}

export const functions = getFunctions(app);

if (import.meta.env.VITE_APP_FUNCTIONS_EMULATOR_PORT !== undefined) {
  connectFunctionsEmulator(functions, "127.0.0.1", parseInt(import.meta.env.VITE_APP_FUNCTIONS_EMULATOR_PORT.trim()));
}

export const database = connectToDatabase();
